/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayerEmailRequestContent
 */
export interface SearchPlayerEmailRequestContent {
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerEmailRequestContent
     */
    searchTerm?: string;
}


/**
 * Check if a given object implements the SearchPlayerEmailRequestContent interface.
 */
export function instanceOfSearchPlayerEmailRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerEmailRequestContentFromJSON(json: any): SearchPlayerEmailRequestContent {
    return SearchPlayerEmailRequestContentFromJSONTyped(json, false);
}

export function SearchPlayerEmailRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerEmailRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'searchTerm': !exists(json, 'searchTerm') ? undefined : json['searchTerm'],
    };
}

export function SearchPlayerEmailRequestContentToJSON(value?: SearchPlayerEmailRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'searchTerm': value.searchTerm,
    };
}

